var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "sidebar",
    class: {
      closed: !_vm.isSidebarVisible && _vm.isOnMobile,
      collapsed: !_vm.isSidebarVisible && !_vm.isOnMobile
    },
    style: {
      maxWidth: _vm.sidebarMaxWidth()
    }
  }, [_c('div', {
    staticClass: "sidebar-header"
  }, [_vm.isSidebarVisible ? _c('div', {
    staticClass: "text-center sidebar-logo"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.goToHome()
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.handleLogoClick.apply(null, arguments);
      }
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.logoUrl,
      "alt": "logo"
    }
  })]), _vm.isLayoutMobile && !_vm.isLayoutMobileLandscape ? _c('span', {
    staticClass: "menu-mobile-close expand-icon-wrapper",
    on: {
      "click": _vm.closeSidebar
    }
  }, [_c('i', {
    staticClass: "fas fa-times fa-2x text-primary"
  })]) : _vm._e()], 1) : _vm._e(), !_vm.isLayoutMobile || _vm.isLayoutMobileLandscape ? _c('button', {
    staticClass: "sidebar-toggle-button",
    attrs: {
      "aria-expanded": _vm.isSidebarVisible
    },
    on: {
      "click": _vm.toggleSidebar
    }
  }, [_c('i', {
    class: _vm.isSidebarVisible ? 'fas fa-chevron-left' : 'fas fa-chevron-right'
  })]) : _vm._e(), _vm.isImpersonating && _vm.isSidebarVisible ? _c('div', {
    staticClass: "border-left border-danger d-flex justify-content-between align-items-center py-2 px-4"
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t("Impersonating user!")))]), _c('button', {
    staticClass: "btn btn-sm btn-danger text-white",
    on: {
      "click": _vm.onExitImpersonationClick
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("Stop")) + " ")])]) : _vm._e(), _vm.showSidebarStructure && _vm.isSidebarVisible ? _c('div', {
    staticClass: "search-form input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.query,
      expression: "query"
    }],
    staticClass: "search form-control px-2",
    attrs: {
      "type": "text",
      "name": "query",
      "placeholder": _vm.$t('Search').toString(),
      "autocomplete": "off"
    },
    domProps: {
      "value": _vm.query
    },
    on: {
      "focus": _vm.onSearchFocus,
      "blur": _vm.onSearchBlur,
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.query = $event.target.value;
      }
    }
  }), _vm.query.length > 0 ? _c('button', {
    staticClass: "btn bg-transparent",
    staticStyle: {
      "margin-left": "-40px",
      "z-index": "100"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        _vm.query = '';
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times text-primary"
  })]) : _vm._e()]) : _vm._e()]), _vm.showSidebarStructure && _vm.isSidebarVisible ? _c('SidebarMenuNew', {
    staticClass: "sidebar-content",
    attrs: {
      "menu": _vm.filteredMenu,
      "open-item-id": _vm.openItemId || '',
      "is-loading": _vm.isMenuRendering
    },
    on: {
      "item-click": _vm.handleItemClick
    }
  }) : _c('div', {
    staticStyle: {
      "flex": "1 1 auto"
    }
  }), _vm.showAdminSearch && _vm.isSidebarVisible ? _c('div', {
    staticClass: "h-100 overflow-hidden"
  }, [_c('FilteredSearch')], 1) : _vm._e(), _vm.showMojElektroSidebar && _vm.isSidebarVisible ? _c('div', {
    staticClass: "h-100 overflow-hidden"
  }, [_c('MojElektroFilters')], 1) : _vm._e(), _vm.isSidebarVisible ? _c('div', {
    class: ['sidebar-footer', {
      'footer-closed': !_vm.isFooterOpen,
      'pt-2': !_vm.isMobileLandscape
    }]
  }, [_vm.isMobileLandscape ? _c('div', {
    staticClass: "w-100 d-flex my-2"
  }, [_c('button', {
    staticClass: "toggle-footer-button w-100 border-0",
    staticStyle: {
      "background-color": "var(--theme-primary)",
      "color": "var(--theme-tertiary)"
    },
    on: {
      "click": _vm.toggleFooter
    }
  }, [_c('i', {
    class: _vm.isFooterOpen ? 'fas fa-chevron-down' : 'fas fa-chevron-up'
  })])]) : _vm._e(), _vm.isFooterOpen ? [_vm.showManageOption ? _c('a', {
    staticClass: "btn btn-sidebar btn-sidebar-full p-3 mb-2",
    attrs: {
      "href": _vm.manageUrl
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.onManageClick.apply(null, arguments);
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-solid fa-location-crosshairs text-primary"
  }), _c('span', [_vm._v(_vm._s(_vm.$t("Manage Location")))])]) : _vm._e(), _vm.isUserBasic ? _c('router-link', {
    staticClass: "btn btn-sidebar btn-sidebar-full p-3 mb-2",
    attrs: {
      "to": {
        path: '/setup'
      }
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.onItemClick2.apply(null, arguments);
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-solid fa-layer-group text-primary"
  }), _c('span', [_vm._v(_vm._s(_vm.$t("setup.title")))])]) : _vm._e(), _c('router-link', {
    staticClass: "btn btn-sidebar btn-sidebar-full p-3 mb-2",
    attrs: {
      "to": {
        path: '/user/settings'
      }
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.onItemClick2.apply(null, arguments);
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-solid fa-gear text-primary"
  }), _c('span', [_vm._v(_vm._s(_vm.$t("User settings")))])]), _vm.$permissions.hasAggregatorRole() ? _c('router-link', {
    staticClass: "btn btn-sidebar btn-sidebar-full p-3 mb-2",
    attrs: {
      "to": {
        path: _vm.companyId ? `/settings/global/companies/${_vm.companyId}` : '/settings/global'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-solid fa-globe text-primary"
  }), _c('span', {
    staticClass: "user-title"
  }, [_vm._v(_vm._s(_vm.$t("Global Settings")))])]) : _vm._e(), _vm.showBackButton ? _c('div', {
    staticClass: "btn btn-sidebar btn-sidebar-full p-3 mb-2",
    on: {
      "click": _vm.onBackButtonClick
    }
  }, [_c('i', {
    staticClass: "fa fa-solid fa-arrow-turn-up text-primary rotate"
  }), _c('span', {
    staticClass: "user-title"
  }, [_vm._v(_vm._s(_vm.$t("Back")))])]) : _vm._e()] : _vm._e()], 2) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }